import { memo, useCallback } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Account } from "@common/types/domains/accounting/account";
import { AccountCombobox } from "@components/accounts/AccountCombobox";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import type {
    CategorizationRow,
    CategorizationTableCallbacks,
    CategorizationTableOptions,
} from "../categorizationTableMeta";

export const CategoryAccountCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, CategorizationRow, string | null>) => {
        const mapping = row.original;
        const { callbacks, options } = useViewTableMeta<
            CategorizationTableCallbacks,
            CategorizationTableOptions
        >(table);

        const selectedAccount =
            mapping.accountId !== null
                ? options?.accountsById[mapping.accountId]
                : undefined;

        const handleChange = useCallback(
            (account: Account | null) => {
                callbacks?.onSelectAccount({
                    taxonomy: mapping.taxonomy,
                    accountId: account?.id ?? null,
                });
            },
            [callbacks, mapping.taxonomy],
        );

        if (!options) {
            return null;
        }

        return (
            <ViewTableCell>
                <AccountCombobox
                    entityId={options.entityId}
                    selectedAccount={selectedAccount}
                    onChange={handleChange}
                    readOnly={!options.canEditMappings}
                    allowedAccountTypes={mapping.allowedAccountTypes}
                    allowedAccountIds={options.assignableAccountIds}
                    addNewAccountButton={false}
                    canClear
                    showAccountCode
                />
            </ViewTableCell>
        );
    },
);
CategoryAccountCell.displayName = "CategoryAccountCell";
